module.exports = __webpack_public_path__ + "static/media/classical.5834f4bc.png";